import { render, staticRenderFns } from "./ProfitSetting.vue?vue&type=template&id=2c081171"
import script from "./ProfitSetting.vue?vue&type=script&lang=js"
export * from "./ProfitSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports